export const HOME_TEXTS = {
  ERROR_MESSAGE:
    'Desculpe, não foi possível buscar as informações dos documentos pendentes.',
}
